const id = "zenuml";
const regexp = /^\s*zenuml/;
const detector = (txt) => {
  return txt.match(regexp) !== null;
};
const loader = async () => {
  const { diagram } = await import("./zenuml-definition-981ee032.js");
  return { id, diagram };
};
const plugin = {
  id,
  detector,
  loader
};
export {
  plugin as default
};
